/**
 * Decorative divider for parchment sections.
 */
export function ParchmentDivider() {
    return (
        <div className="flex items-center justify-center gap-2 my-6">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent via-amber-800/30 to-transparent" />
            <span className="text-amber-800/40 text-lg">✦</span>
            <div className="h-px flex-1 bg-gradient-to-r from-transparent via-amber-800/30 to-transparent" />
        </div>
    );
}
